import {Vector2} from "../utils/Vector2";
function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}


export class InputManager {
    pointers:Pointer[]
    element:HTMLElement

    constructor (element?:HTMLElement){

        const manager = {
            pointers: [],
            element:element
        } as InputManager;

        const options = {passive: true, capture:true}

        if(!isTouchDevice())
        {
            window.addEventListener("mousedown", (e) => mouseDown(manager, e), options);
            window.addEventListener("mousemove", (e) => mouseMove(manager, e), options);
            window.addEventListener("mouseup", (e) => mouseUp(manager, e), options);
        }
        else{

            window.addEventListener("touchstart", (e) => touchStart(manager, e), options);
            window.addEventListener("touchmove", (e) => touchMove(manager, e), options);
            window.addEventListener("touchend", (e) => touchEnd(manager, e), options);
            window.addEventListener("touchcancel", (e) => touchEnd(manager, e), options);
        }


        return manager
    }
}


export class Pointer{
    timestamp:number
    prevTimestamp: number
    identifier: number
    prevPosition?: Vector2
    position: Vector2
    isPressed: boolean

    constructor( identifier:number) {

        this.identifier = identifier
    }
}

const createPointer = (manager:InputManager, id:number) : Pointer => {
   const p = new Pointer(id)
    manager.pointers.push(p)
    return p
}
const getMousePointer = (manager:InputManager):Pointer => {

    let mouse = manager.pointers.find(p => p.identifier === -1)
    if (!mouse) {
        mouse = createPointer(manager, -1)
    }
    return mouse;
}


const mouseDown = (manager:InputManager, event:MouseEvent) => {

    if (event.button !== 0)
        return

    const pointer = getMousePointer(manager)
    const pos = getPoint(manager, event)

    pointerPress(manager,pointer, pos)
}

const mouseMove = (manager:InputManager, event:MouseEvent) => {
    const pointer = getMousePointer(manager)
    const newPosition = getPoint(manager, event)
    pointerMove(manager,pointer, newPosition)
}


const mouseUp = (manager:InputManager, event:MouseEvent) => {
    const pointer = getMousePointer(manager)
    pointer.isPressed = false;
}

const touchStart = (manager:InputManager, event:TouchEvent) => {

    for (let i = 0; i < event.changedTouches.length; i++) {
        const touch = event.changedTouches[i];

        const pointer = createPointer(manager, touch.identifier)
        const pos = getPoint(manager, touch)

        pointerPress(manager,pointer, pos)
    }
}

const touchMove = (manager:InputManager, event:TouchEvent) => {

    for (let i = 0; i < event.changedTouches.length; i++) {
        const touch = event.changedTouches[i];

        const pointer = manager.pointers.find(p => p.identifier === touch.identifier)
        const newPosition = getPoint(manager, touch)

        pointerMove(manager,pointer, newPosition)
    }
}

const touchEnd = (manager:InputManager, event:TouchEvent) => {

    for (let i = 0; i < event.changedTouches.length; i++) {
        const touch = event.changedTouches[i];
        const index = manager.pointers.findIndex(p => p.identifier === touch.identifier)
        manager.pointers[index].isPressed = false
        manager.pointers.splice(index, 1)

    }
}

const transform = (manager:InputManager,position:Vector2) =>
{
    if(manager.element)
    {
        return transformPositionToElementSpace(position,manager.element)
    }
    return position
}

const pointerMove = (manager:InputManager,pointer:Pointer, newPosition:Vector2) => {

    pointer.prevPosition = pointer.position;
    pointer.position = transform(manager, newPosition)
    pointer.prevTimestamp = pointer.timestamp;
    pointer.timestamp = Date.now()
}

const pointerPress = (manager:InputManager,pointer:Pointer, pos:Vector2) => {
    pos = transform(manager,pos)
    pointer.isPressed = true;
    pointer.position = pos;
    pointer.prevPosition = pos;
    pointer.prevTimestamp = undefined
    pointer.timestamp = Date.now()
}

const getPoint = (manager:InputManager, event:MouseEvent|Touch):Vector2 => {
    return new Vector2( event.clientX, event.clientY)
}

export const getVelocity = (pointer:Pointer) => {

    const timeThreshold = 100
    if (!pointer.prevTimestamp ||
        Date.now() - pointer.timestamp > timeThreshold) {
        return new Vector2(0, 0)
    }


    let dtMs = (pointer.timestamp - pointer.prevTimestamp)
    if (dtMs < .00001) {
        dtMs = 1;
    }
    const dt = dtMs / 1000
    const deltaX = pointer.position.x - pointer.prevPosition.x
    const deltaY = pointer.position.y - pointer.prevPosition.y
    return new Vector2(deltaX / dt, deltaY / dt)

}

const transformPositionToElementSpace = (position, element) =>
{
    let rect = element.getBoundingClientRect();

    return new Vector2(
        (position.x - rect.left) * (typeof (element.width) === 'number' ? element.width / element.clientWidth : 1),
        (position.y - rect.top) * (typeof (element.height) === 'number' ? element.height / element.clientHeight : 1),
    );
}
